import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth, db } from '../FirebaseComp/firebase';
import { doc, getDoc } from 'firebase/firestore';
import './login.css';

function SignIn() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();


  
const handleLogin = async (e) => {
  e.preventDefault();
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const userId = userCredential.user.uid;

    try {
      // Check if the user is an admin (in 'admins' collection)
      const adminDoc = await getDoc(doc(db, 'admins', userId));
      if (adminDoc.exists()) {
        navigate('/adminpanel');
        return; // Exit after successful admin check
      }

      // Check if the user is an accountant (in 'accountants' collection)
      const accountantDoc = await getDoc(doc(db, 'accountant', userId));
      if (accountantDoc.exists()) {
        navigate('/adminpanelmoratuwa');
        return; // Exit after successful accountant check
      }

      // Check if the user is a normal user (in 'users' collection)
      const userDoc = await getDoc(doc(db, 'users', userId));
      if (userDoc.exists()) {
        navigate('/'); // Normal users go to home
        return;
      }

      // If user doesn't exist in any collection
      setError('No access permissions found');
      await auth.signOut(); // Optional: Force logout if no role is assigned
    } catch (firestoreError) {
      console.error('Error:', firestoreError);
      setError('Error verifying user permissions');
    }
  } catch (authError) {
    console.error('Login Error:', authError);
    setError(authError.message || 'Invalid email or password');
  }
};




  
  const navigateToForgotPassword = () => {
   
    navigate('/ForgotPassword');
  };

  
  return (
    <div className="form-container-panel">
      <h2>Sign In</h2>
      {error && <p className="error-message">{error}</p>}
      <form onSubmit={handleLogin}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        
        <button type="submit" className="form-btn-panel">Login</button>

             <a 
                href="/ForgotPassword" 
                className="forgot-password-link"
                onClick={(e) => {
                  e.preventDefault(); // Prevent default action if using JavaScript handling
                  navigateToForgotPassword(); // Optional: Function to navigate programmatically
                }}
              >
                Forgot Password?
              </a>

      </form>
    </div>
  )
}

export default SignIn